import React from "react";
import { IonToast } from "@ionic/react";

/**
 * Component for displaying error and toast alerts
 */
export const ErrorAlert = ({ onCloseMessage, onDismiss }) => {
  if (!onCloseMessage?.error) return null;

  return (
    <IonToast
      isOpen={!!onCloseMessage}
      onDidDismiss={onDismiss}
      message={onCloseMessage.message}
      buttons={[{
        text: 'Zavřít',
        role: 'cancel'
      }]}
    />
  );
};

export const ToastAlert = ({ showToast, toastMessage, onDismiss }) => {
  return (
    <IonToast
      isOpen={showToast}
      onDidDismiss={onDismiss}
      message={toastMessage}
      duration={5000}
    />
  );
};

